// src/components/pages/DoorsWithIp.jsx
import React, { useEffect } from "react";
import { Flex, Box, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { useDoorData } from "../context/DoorContext";
import EmergencyButtonsAllips from "../EmergencyButtonsAllips";
import DoorItemIp from "../DoorItemIp";
import AccessLogCardIps from "../AccessLogCardIps";

function DoorsWithIp() {
  const { user, getAllSystemDoors } = useDoorData();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  // 👇 vieną kartą užkraunam visas duris su DoorSerial
useEffect(() => {
  if (!user) return;  
  getAllSystemDoors();

}, []);



  // return (
  // <>
  //       <EmergencyButtonsAllips />
  //       <DoorItemIp />
  //       <AccessLogCardIps />
  //        </>
  // );
  return (
    <Flex direction="column" minH="100vh">
      {/* Viršutinė dalis */}
      <Box flex="1" mx="5vw" mt={4}>
        <EmergencyButtonsAllips />
        <DoorItemIp />
      </Box>

      {/* Apačioje prilipęs logas */}
      <Box position="sticky" bottom="0" zIndex="20" bg="white">
        <AccessLogCardIps />
      </Box>
    </Flex>
  );
}

export default DoorsWithIp;
